// src\themes\lino\components\TextWidget.tsx
'use client';

import { motion } from 'motion/react';
import { loadThemeComponent } from "@/core/config/theme-component-loader";
import Link from "next/link";
import { textGroupVariants, textItemVariants } from "./animations/textReveal";

const CustomButton = loadThemeComponent("CustomButton")


type TextItem = {
    title?: string;
    description?: string;
    width?: string;
    buttonContent?: string;
    link?: string;
};

type GlobalWidgetItem = {
    direction?: 'left' | 'center' | 'right';
    items?: TextItem[];
    textItems?: TextItem[];
    width?: string;
};

// وقتی animateText=true باشه (فعلاً فقط صفحه اصلی)، تیتر/توضیح/دکمه به سبک
// اپل با یه تاخیر کوتاه نسبت به هم وارد صفحه می‌شن. جای دیگه‌ای که این پراپ
// پاس داده نشه، دقیقاً همون رفتار قبلی (بدون انیمیشن متن) حفظ می‌شه.
export default function TextWidget({ data, animateText = false }: { data: GlobalWidgetItem; animateText?: boolean }) {

    const textAlign = data.direction === 'center' ? 'text-center' : data.direction === 'right' ? 'text-start' : 'text-end';
    const widthMap: Record<string, string> = {
        '1/1': 'col-span-12',
        '1/2': 'col-span-12 md:col-span-6',
        '1/3': 'col-span-12 md:col-span-4',
        '1/4': 'col-span-12 md:col-span-3',
        '2/3': 'col-span-12 md:col-span-8',
        '3/4': 'col-span-12 md:col-span-9',
    };

    const widgetWidth = widthMap[data.width || '1/1'];

    if (!animateText) {
        return (
            <div className={`${widgetWidth} m-auto justify-center flex flex-col space-y-8 h-full w-full ${textAlign}`}>
                {data.items?.map((item, index) => (
                    <div key={index} className="justify-center flex flex-col space-y-3">
                        {item.title && <h2 className="text-xl lg:text-2xl font-light text-primary-900 tracking-tight">{item.title}</h2>}
                        {item.description && <p className="text-primary-600 text-[13px] whitespace-pre-line leading-6">{item.description}</p>}
                        {item.buttonContent && item.link && (
                            <div className="w-fit">
                                <CustomButton asChild variant="outline" className="mt-2">
                                    <Link href={item.link}>
                                        {item.buttonContent}
                                    </Link>
                                </CustomButton>
                            </div>
                        )}
                    </div>
                ))
                }
            </div >
        );
    }

    return (
        <div className={`${widgetWidth} m-auto justify-center flex flex-col space-y-8 h-full w-full ${textAlign}`}>
            {data.items?.map((item, index) => (
                <motion.div
                    key={index}
                    className="justify-center flex flex-col space-y-3"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.4 }}
                    variants={textGroupVariants}
                >
                    {item.title && (
                        <motion.h2 variants={textItemVariants} className="text-xl lg:text-2xl font-light text-primary-900 tracking-tight">
                            {item.title}
                        </motion.h2>
                    )}
                    {item.description && (
                        <motion.p variants={textItemVariants} className="text-primary-600 text-[13px] whitespace-pre-line leading-6">
                            {item.description}
                        </motion.p>
                    )}
                    {item.buttonContent && item.link && (
                        <motion.div variants={textItemVariants} className="w-fit">
                            <CustomButton asChild variant="outline" className="mt-2">
                                <Link href={item.link}>
                                    {item.buttonContent}
                                </Link>
                            </CustomButton>
                        </motion.div>
                    )}
                </motion.div>
            ))
            }
        </div >
    );
}